import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { FormBuilderThemes, GetEnumValuesDto } from 'src/app/core/api/models';
import { ImageUploaderComponent } from 'src/app/shared/components/image-uploader/image-uploader.component';
import { FormBuilderThemeColorDirective } from './form-builder-theme-color.directive';

@Component({
  selector: 'forms-management-appearance-setting',
  templateUrl: './forms-management-appearance-setting.component.html',
  imports: [
    ImageUploaderComponent,
    CommonModule,
    FormBuilderThemeColorDirective,
    TranslateModule,
  ],
})
export class FormsManagementAppearanceSettingComponent {
  //#region properties
  @Input() formBuilderThemesEnumValues: GetEnumValuesDto[] = [];
  @Input() selectedTheme: FormBuilderThemes;
  @Input() imageUrl: string = '';
  @Input() imageLoading: boolean = false;

  @Output() file = new EventEmitter<any>();
  @Output() theme = new EventEmitter<FormBuilderThemes>();
  //#endregion

  onSelectedTheme(theme: FormBuilderThemes) {
    this.selectedTheme = theme;
    this.theme.emit(theme);
  }

  emitFile(event: any) {
    this.file.emit(event);
  }
}
